import { sanitizeHtml } from '@insta-club/utilities';

const DashboardHeading = ({ content }: { content: string }) => {
    const cleanHtml = sanitizeHtml(content);

    return (
        <div className='relative py-4 pb-0'>
            {/* <div className='bg-primary-200 absolute top-16 right-0 z-0 h-2 w-2 rounded-full' /> */}
            <div className='bg-primary-200 absolute bottom-2 left-10 z-0 h-2 w-2 rounded-full sm:left-16' />
            <div className='absolute top-2 left-16 z-0 h-3 w-3 rounded-full bg-yellow-200 sm:left-28' />
            <div className='bg-primary-200 absolute top-4 left-0 z-0 h-5 w-5 rounded-full sm:left-8' />
            <div className='relative flex flex-col gap-1 text-2xl font-bold text-gray-800'>
                <p className='w-full break-words whitespace-normal' dangerouslySetInnerHTML={{ __html: cleanHtml }}></p>
            </div>
        </div>
    );
};

export default DashboardHeading;

